module.exports = __webpack_public_path__ + "img/th_th.1534cc0f.png";